import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { CancelForAnyReasonState } from "./types";

export const getCancelForAnyReasonMachine = (config: ChildMachineConfig) => ({
  initial: CancelForAnyReasonState.route,
  states: {
    [CancelForAnyReasonState.route]: {
      always: [
        {
          target: CancelForAnyReasonState.addProduct,
          cond: GuardTypes.hasCfarIdAndEnabled,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [CancelForAnyReasonState.addProduct]: {
      always: [
        {
          actions: ActionTypes.addCfarProduct,
          target: config.nextState,
        },
      ],
    },
  },
});
